import { request } from '@/util/http'

// ==================== 设备管理 ====================

/**
 * 设备物流列表（分页）
 *
 * @param current 当前页
 * @param size 每页条数
 * @param params 搜索条件（orderId / wxUserId / status）
 */
export const getDeviceList = (current, size, params) => {
  return request({
    url: '/health/admin/device/list',
    method: 'get',
    params: {
      current,
      size,
      ...params
    }
  })
}

/**
 * 设备详情
 *
 * @param orderId 订单ID
 */
export const getDeviceDetail = (orderId) => {
  return request({
    url: '/health/admin/device/detail',
    method: 'get',
    params: {
      orderId
    }
  })
}

/**
 * 发货
 *
 * @param data { orderId, expressNo, expressCompany, deviceSn }
 */
export const dispatchDevice = (data) => {
  return request({
    url: '/health/admin/device/dispatch',
    method: 'post',
    data: data
  })
}

/**
 * 确认平台收到回寄设备
 *
 * @param orderId 订单ID
 */
export const confirmPlatformReceive = (orderId) => {
  return request({
    url: '/health/admin/device/confirm-platform-receive',
    method: 'post',
    params: {
      orderId
    }
  })
}

/**
 * 开始检测
 *
 * @param orderId 订单ID
 */
export const startDetect = (orderId) => {
  return request({
    url: '/health/admin/device/start-detect',
    method: 'post',
    params: {
      orderId
    }
  })
}

/**
 * 审核（通过/驳回
 *
 * @param data { orderId, pass, rejectReason }
 */
export const auditDevice = (data) => {
  return request({
    url: '/health/admin/device/audit',
    method: 'post',
    data: data
  })
}

// ==================== 提现管理 ====================

/**
 * 提现列表（分页）
 *
 * @param current 当前页
 * @param size 每页条数
 * @param params 搜索条件（applyNo / orderId / status）
 */
export const getWithdrawalList = (current, size, params) => {
  return request({
    url: '/health/admin/withdrawal/list',
    method: 'get',
    params: {
      current,
      size,
      ...params
    }
  })
}

/**
 * 人工转账完成
 *
 * @param data { applyNo, manualTransferNo, voucherUrl }
 */
export const manualComplete = (data) => {
  return request({
    url: '/health/admin/withdrawal/manual-complete',
    method: 'post',
    data: data
  })
}

/**
 * 人工转账失败
 *
 * @param data { applyNo, failReason }
 */
export const manualFail = (data) => {
  return request({
    url: '/health/admin/withdrawal/manual-fail',
    method: 'post',
    data: data
  })
}

/**
 * 协商转账
 *
 * @param data { orderId, amount, bankCardNo, bankAccountName, bankName }
 */
export const negotiateTransfer = (data) => {
  return request({
    url: '/health/admin/withdrawal/negotiate-transfer',
    method: 'post',
    data: data
  })
}

/**
 * 客服手动解冻
 *
 * @param data { applyNo, reason }
 */
export const manualUnfreeze = (data) => {
  return request({
    url: '/health/admin/withdrawal/manual-unfreeze',
    method: 'post',
    data: data
  })
}

// ==================== 预创建记录 ====================

/**
 * 预创建记录列表（分页）
 *
 * @param current 当前页
 * @param size 每页条数
 * @param params 搜索条件（outBillNo / orderId）
 */
export const getPrecreateList = (current, size, params) => {
  return request({
    url: '/health/admin/precreate/list',
    method: 'get',
    params: {
      current,
      size,
      ...params
    }
  })
}

/**
 * 核实预创建记录
 *
 * @param data { outBillNo, result, remark }
 */
export const verifyPrecreate = (data) => {
  return request({
    url: '/health/admin/precreate/verify',
    method: 'post',
    data: data
  })
}
